import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/latestAnalysis'
import { Error } from '../../actions/error/error'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';

function* process(action) {
  try {
    const {
      include_logs = false,
      skip_refresh = false,
    } = action.payload || {};

    const params = [];
    if (include_logs) params.push('include_logs=true');
    if (skip_refresh) params.push('skip_refresh=true');
    const queryParams = params.length ? `?${params.join('&')}` : '';

    const response = yield call(
        axios.get,
        `${config.API_URL}/signal/latest-analysis${queryParams}`,
        { headers: getLocalUser() }
      );

    // Extract the actual analysis data from the nested structure
    const analysisData = response.data.data || response.data;

    // "Insufficient Data" is expected when a workspace has no signals yet;
    // surface it as a successful but empty response so the UI can show
    // an onboarding state instead of an error toast.
    if (analysisData.error === "Insufficient Data") {
      yield put(fetchSuccess({
        status: 'insufficient_data',
        error: analysisData.error,
        message: analysisData.message,
        results: null,
      }));
      return;
    }

    // 202 "Analysis Started" - first time, no completed analysis yet.
    // Pass through so the UI can show a "running" state and poll.
    if (analysisData.error === "Analysis Started") {
      yield put(fetchSuccess({
        status: 'queued',
        message: analysisData.message,
        analysis_id: analysisData.analysis_id,
        refresh_in_progress: true,
        refresh_reason: analysisData.refresh_reason,
        pending_progress: analysisData.pending_progress || null,
        results: null,
      }));
      return;
    }

    // Normal success path. The backend now also returns:
    //   is_stale, stale_reason, refresh_in_progress,
    //   pending_analysis_id, pending_status
    // so the UI can show "refreshing..." over the cached analysis.
    yield put(fetchSuccess(analysisData));
  } catch (error) {
    // Check if this is an "Insufficient Data" error response
    const errorData = error?.response?.data?.data || error?.response?.data;
    if (errorData?.error === "Insufficient Data") {
      yield put(fetchSuccess({
        status: 'insufficient_data',
        error: errorData.error,
        message: errorData.message,
        results: null,
      }));
    } else {
      yield put(Error(error));
      yield put(fetchFailure(
        error?.response?.data?.error
          || error?.message
          || 'Failed to fetch latest analysis'
      ));
    }
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
} 